<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 报表管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>包装关联</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px" @keyup.enter.native="search()">
          <el-row>
            <el-col :span="6">
              <el-form-item label="订单" prop="orderNo">
                <el-input v-model="searchform.orderNo" style="width:100%" clearable placeholder="请输入订单"/>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="批次号" prop="batchno">
                <el-input v-model="searchform.batchno" style="width:100%" clearable placeholder="请输入批次号"/>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="子级码" prop="qrcode">
                <el-input v-model="searchform.qrcode" style="width:100%" clearable placeholder="请输入子级码"/>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="父级码" prop="qrcode_parent">
                <el-input v-model="searchform.qrcode_parent" style="width:100%" clearable placeholder="请输入父级码"/>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产品编码" prop="productCode">
                <el-select style="width:100%" v-model="searchform.productCode" placeholder="请输入产品名称模糊匹配或者下拉选择"
                  :remote-method="getproductlist" filterable remote :loading="productloading" :disabled="show">
                  <el-option v-for="item in productlist" :key="item.product_code" :label="item.product"
                    :value="item.product_code" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="包装级别" prop="level">
                <el-select v-model="searchform.level" placeholder="请选择包装级别">
                  <el-option v-for="item in levellist" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="1">
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button type="primary" icon="el-icon-search" @click="search"
                v-permission="['relevance_select']">搜索</el-button>
              <!-- <el-button
                v-permission="['relevance_export']"
                :loading="downloadLoading"
                type="primary"
                icon="document"
                @click="handleDownload"
              >导出Excel</el-button> -->
            </el-col>
          </el-row>
        </el-form>
        <br />
      </div>

      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>包装关联查询</h4>
          <el-divider></el-divider>
          <el-table border v-loading="listLoading" element-loading-text="拼命加载中" :data="tableData" style="width:100%;"
            id="parent">
            <af-table-column prop="orderno" label="订单" min-width="100" show-overflow-tooltip></af-table-column>
            <af-table-column prop="batchno" label="批次号" min-width="100" show-overflow-tooltip></af-table-column>
            <af-table-column prop="factory" label="工厂" min-width="120" show-overflow-tooltip></af-table-column>
            <af-table-column prop="child_num" label="子级生产数量" min-width="120" show-overflow-tooltip></af-table-column>
            <af-table-column prop="child_num_relation" label="子级采集数量" min-width="120"
              show-overflow-tooltip></af-table-column>
            <af-table-column prop="product_code" label="产品编码" min-width="200" show-overflow-tooltip></af-table-column>
            <af-table-column prop="product_name" label="产品名称" min-width="200" show-overflow-tooltip></af-table-column>
            <af-table-column prop="specs" label="规格" min-width="120" show-overflow-tooltip></af-table-column>
            <af-table-column prop="qrcode" label="子级码" min-width="100" show-overflow-tooltip></af-table-column>
            <af-table-column prop="qrcode_parent" label="父级码" min-width="100" show-overflow-tooltip></af-table-column>
            <af-table-column prop="create_time" label="生产时间" min-width="100" show-overflow-tooltip>
              <template slot-scope="scope">{{ $parseTime(scope.row.create_time) }}</template>
            </af-table-column>
          </el-table>
          <br />
          <el-pagination background @current-change="currentchange" @size-change="pagesize"
            :current-page.sync="currentPage" :page-sizes="[20, 30, 40, 50]" layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"></el-pagination>
        </el-col>
      </el-row>
    </div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <h4>备注：</h4>
      </div>
      <span>输入盒码关联箱码，输入箱码关联盒码</span>
    </el-card>
  </div>
</template>
<script>
import { packquery } from "@/api/plant";
import { productlist } from "@/api/base";
export default {
  mounted() { },
  data() {
    return {
      //基础数据
      listLoading: false,
      depart_uuid: [],
      tableData: [],
      levellist: [
        {
          value: 1,
          label: "一级包装-二级包装"
        },
        {
          value: 2,
          label: "二级包装-三级包装"
        },
        {
          value: 3,
          label: "三级包装-四级包装"
        }
        //    {
        //   value:4,
        //   label:"四级包装-五级包装"

        // }
      ],
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
      //导出表格变量
      tableDataDownload: [],
      downloadLoading: false,
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
      //搜索表单数据
      searchform: {
        qrcode_parent: null,
        batchno: null,
        productCode: null,
        orderNo: null,
        qrcode: null,
        level: 1,
        pageIndex: 1,
        pageSize: 20
      },
      productloading: false,
      show: false,
      productlist: [] //产品列表下拉
    };
  },
  mounted() {
    this.getproductlist();
  },
  methods: {
    // 获取产品下拉
    getproductlist(value) {
      this.productlist = [];
      if (value !== "") {
        this.productloading = true;
        setTimeout(() => {
          this.productloading = false;
          productlist({ productName: value }).then(response => {
            this.productlist = response.data.data;
            for (var i = 0; i < this.productlist.length; i++) {
              this.productlist[i].product =
                this.productlist[i].product_code +
                "   " +
                this.productlist[i].product_name;
            }
          });
        }, 200);
      } else {
        this.productlist = [];
      }
    },
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      packquery(obj).then(response => {
        this.packdate(response.data.data);
        this.tableData = response.data.data;
        this.currentPage = response.data.page_index;
        this.total_count = response.data.total_count;
        this.listLoading = false;
        console.log(this.tableData);
      });
    },
    packdate(obj) {
      for (let i = 0; i < obj.length; i++) {
        obj[i].supplier_id =
          (obj[i].supplier_id || "") + (obj[i].supplier_name || "");
        obj[i].factory =
          (obj[i].factory_code || "") + (obj[i].factory_name || "");
      }
    },
    //搜索事件
    search() {
      this.Tabledata({
        level: this.searchform.level,
        qrcode_parent: this.searchform.qrcode_parent,
        batchno: this.searchform.batchno,
        productCode: this.searchform.productCode,
        orderNo: this.searchform.orderNo,
        qrcode: this.searchform.qrcode,
        pageSize: this.searchform.pageSize
      });
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //分页跳转事件
    currentchange(pageIndex) {
      this.searchform.pageIndex = pageIndex;
      this.Tabledata({
        level: this.searchform.level,
        qrcode_parent: this.searchform.qrcode_parent,
        batchno: this.searchform.batchno,
        productCode: this.searchform.productCode,
        orderNo: this.searchform.orderNo,
        qrcode: this.searchform.qrcode,
        pageSize: this.searchform.pageSize,
        pageIndex: this.searchform.pageIndex
      });
    },
    //分页每页显示条数事件
    pagesize(pageSize) {
      this.searchform.pageSize = pageSize;
      this.search();
    },
    //导出表格事件
    handleDownload() {
      this.downloadLoading = true;
      const obj = {
        page_index: 1,
        pageSize: this.total_count,
        level: this.searchform.level,
        qrcode_parent: this.searchform.qrcode_parent,
        batchno: this.searchform.batchno,
        productCode: this.searchform.productCode,
        orderNo: this.searchform.orderNo,
        qrcode: this.searchform.qrcode
      };
      packquery(obj).then(response => {
        this.packdate(response.data.data);
        this.tableDataDownload = response.data.data;

        console.log(this.tableDataDownload);
        import("@/vendor/Export2Excel").then(excel => {
          const tHeader = ["订单", "批次号", "工厂", "子级生产数量", "子级采集数量", "产品", "子级码", "父级码"];
          const filterVal = [
            "orderno",
            "batchno",
            "factory",
            "child_num",
            "child_num_relation",
            "product_code",
            "qrcode",
            "qrcode_parent"
          ];
          const list = this.tableDataDownload;
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth,
            bookType: this.bookType
          });
          this.downloadLoading = false;
        });
      }); // hear
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    //跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit"
      });
    }
  }
};
</script>
<style scoped></style>